import * as React from 'react';
import * as S from './styles';
import { shallowEqual, useDispatch, useSelector } from 'react-redux';
import { RootState } from 'store/types';
import { ICopyCodeProps } from './types';
import CopyIcon from 'common/icons/copyIcon';

const CopyCodePanel: React.FC<ICopyCodeProps> = (props) => {
    const dispatch = useDispatch();
    const {
        widgetsCalls,
    } = useSelector((rootState: RootState) => {
        return {
            widgetsCalls: rootState.reviews.widgetsCalls,
        }
    }, shallowEqual);

    const widgetCall = props.selectedTab === "entire" ? widgetsCalls?.entireCall : (props.widgetType === "overallRating" ? widgetsCalls?.overallRatingCall: (props.widgetType === "providersRating" ? widgetsCalls?.providersRatingCall: (props.widgetType === "topReviews" ? widgetsCalls?.topReviewsCall: (props.widgetType === "leaveReview" ? widgetsCalls?.leaveReviewCall: (props.widgetType === "reviewList" ? widgetsCalls?.reviewListCall: ""))))); 

    const useOutside = (ref:any) => {
        React.useEffect(() => {
          const handleClickOutside = (event:any) => {
            if (ref.current && !ref.current.contains(event.target)) {
              props.setOpen(false);
            }
          }
          document.addEventListener("mousedown", handleClickOutside);
          return () => {
            document.removeEventListener("mousedown", handleClickOutside);
          };
        }, [ref]);
      }
    
      const panelRef = React.useRef(null);
      useOutside(panelRef);
      
      function handleCopyCodeClick(event) {
        navigator.clipboard.writeText(widgetCall??"");
      }
  
      return (
        <S.Root ref={panelRef} xClickPosition={props.xPosition} yClickPosition={props.yPosition}>
            <S.Message>
                Please copy the code below and paste it inside the &lt;body&gt; tag of your HTML.
            </S.Message>
            <S.CodeBox>
                <S.HtmlText>
                    {
                        widgetCall
                    }
                </S.HtmlText>
                <S.CopyOuterContainer>
                <S.CopyContainer onClick={(event) => handleCopyCodeClick(event)}
                    >
                        <CopyIcon />
                </S.CopyContainer>
                </S.CopyOuterContainer>
            </S.CodeBox>
        </S.Root>
    )
}

export default CopyCodePanel;
